import React from "react";
import { spotlight_mobile } from "@/generated";
import { LazyLoadImage } from "react-lazy-load-image-component";

interface LoaderProps {
  onClick?: () => void;
  spotlight: spotlight_mobile;
  onView?: () => void;
}

const AdBanner: React.FC<LoaderProps> = (props) => {
  const { onClick, spotlight, onView } = props;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 w-full flex items-center justify-center "
      onClick={onClick}
    >
      <LazyLoadImage
        src={spotlight.picture_url}
        alt="Spotlight Banner"
        width={375}
        height={80}
        className="object-cover w-full  max-h-20"
        onLoad={onView}
      />
    </div>
  );
};

export default AdBanner;
